import React, { PropTypes } from 'react';
import dateformat from 'dateformat';

import classNames from 'classnames';

const CurrentTimeLabel = props => {
  const { visibleTimestamp, format } = props;
  // round to nearest 5 Min
  const coeff = 300000;
  const rounded = new Date(Math.round(visibleTimestamp / coeff) * coeff);

  const currentFormatted = dateformat(new Date(rounded), format || 'HH:MM');
  const currentDayFormatted = dateformat(new Date(rounded), format || 'dd.mm.');
  const weekdays = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  const dayOfTheWeek = weekdays[new Date(rounded).getDay()];

  const timeLabelStyles = classNames(
    'mt-control-item',
    'mt-current-time-label',
    'text--blue-dark'
  );
  const timeLabelPrognose = classNames(
    'mt-current-time-label-prognose',
    {
      'mt-current-time-label-prognose-active': props.prognoseAfterTimestamp && props.prognoseAfterTimestamp < props.visibleTimestamp,
    });
  return (
    <div className={timeLabelStyles}>
      <div className="mt-current-time-label-time">{props.show_time ? currentFormatted : currentDayFormatted}</div>
      <div className="mt-current-time-label-wrapper">
        <div className="mt-current-time-label-day">{props.show_time ? `${dayOfTheWeek.substring(0, 2)}. ${currentDayFormatted}` : `${dayOfTheWeek}`}</div>
      </div>
    </div>
  );
};

CurrentTimeLabel.defaultProps = {
  show_date: true,
  show_time: true,
};

CurrentTimeLabel.propTypes = {
  props: PropTypes.object,
  products: PropTypes.array,
};

export default CurrentTimeLabel;



/** WEBPACK FOOTER **
 ** ./core_components/TimingHandler/TimeNavigation/controls/CurrentTimeLabel.js
 **/